import React from 'react';

const StatCard = ({ label, value, className = "text-purple-600 dark:text-purple-400" }) => {
  return (
    <div className="bg-white dark:bg-gray-800 p-4 md:p-6 rounded-lg shadow-lg">
      <p className="text-xs md:text-sm text-gray-600 dark:text-gray-300 mb-1">{label}</p>
      <p className={`text-xl md:text-2xl font-bold ${className}`}>{value}</p>
    </div>
  );
};

export default StatCard;